import { NavigationReducerType } from "./types";
import { Location } from "../models";

/**
 * Push the given `location` to the `locationStack`.
 *
 * @param location Location
 * @param NavigationReducerType
 *
 * @return NavigationReducerType
 */
export const addToLocationStack = (location: Location, state: NavigationReducerType) => {
  return { ...state, locationStack: [...state.locationStack, location] };
};

/**
 * Pop the last element from the `locationStack`
 *
 * @param NavigationReducerType
 *
 * @return NavigationReducerType
 */
export const popFromLocationStack = (state: NavigationReducerType) => {
  return { ...state, locationStack: state.locationStack.slice(0, -1) };
};

/**
 * Set the given `boolean` value as the `forceFetching`.
 *
 * @param boolean
 * @param NavigationReducerType
 *
 * @return NavigationReducerType
 */
export const setForceFetching = (
  forceFetching: boolean,
  state: NavigationReducerType,
): NavigationReducerType => ({ ...state, forceFetching });
